import React, { useEffect, useState } from "react";
import ResearchLayout, { useReveal } from "../ResearchLayout";
import makeRequest from "../../../makeRequest";
import { ROLE_PALETTE } from "../researchApi";

export default function Certifications() {
  useReveal();
  const [loading, setLoading] = useState(true);
  const [certs, setCerts] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await makeRequest({ route: "/website/research-certification/public", method: "get" });
        if (mounted) setCerts(Array.isArray(res?.data) ? res.data : []);
      } catch (e) {
        console.error("Failed to load certifications:", e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <ResearchLayout>
      <section
        style={{
          padding: "100px 0 60px",
          background: "linear-gradient(135deg, #0d3b6e 0%, #076cec 100%)",
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="rs-blob" style={{ width: 400, height: 400, background: "#10b981", top: "-150px", right: "-100px" }} />
        <div className="rs-container rs-text-center" style={{ position: "relative", zIndex: 2 }}>
          <span className="rs-section-eyebrow" style={{ background: "rgba(255,255,255,0.15)", color: "#fff", backdropFilter: "blur(10px)" }}>
            Training & Standards
          </span>
          <h1 style={{ fontSize: "clamp(2rem, 5vw, 3.4rem)", fontWeight: 800, margin: "12px 0 16px" }}>Clinical Research Certifications</h1>
          <p style={{ fontSize: "1.05rem", maxWidth: 720, margin: "0 auto", opacity: 0.85, lineHeight: 1.7 }}>
            Our team maintains internationally recognized certifications to ensure the highest standards of clinical research practice.
          </p>
        </div>
      </section>

      <section className="rs-section" style={{ paddingTop: 60 }}>
        <div className="rs-container">
          {loading ? (
            <div style={{ padding: "60px 20px", textAlign: "center", color: "#6b7280" }}>
              <i className="fa-regular fa-spinner fa-spin" style={{ fontSize: "1.8rem", color: "var(--rs-primary)", marginBottom: 12 }}></i>
              <div>Loading certifications…</div>
            </div>
          ) : certs.length === 0 ? (
            <div
              style={{
                padding: "50px 30px",
                textAlign: "center",
                background: "linear-gradient(135deg, #f0f7ff, #e6fffa)",
                borderRadius: 18,
                border: "1px dashed rgba(7, 108, 236,0.2)",
              }}
            >
              <h3 style={{ margin: "0 0 8px", color: "var(--rs-dark)", fontWeight: 800 }}>No certifications yet</h3>
              <p style={{ color: "#6b7280", margin: 0 }}>Add Research Certifications from the admin panel to populate this section.</p>
            </div>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
                gap: 26,
              }}
            >
              {certs.map((c, i) => (
                <div
                  key={c.id}
                  className={`rs-reveal delay-${(i % 4) + 1}`}
                  style={{
                    background: "#fff",
                    borderRadius: 22,
                    overflow: "hidden",
                    border: "1px solid rgba(7, 108, 236,0.08)",
                    transition: "all 0.3s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px)";
                    e.currentTarget.style.boxShadow = "0 22px 50px rgba(7, 108, 236,0.14)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div
                    style={{
                      background: ROLE_PALETTE[i % ROLE_PALETTE.length],
                      padding: "36px 30px",
                      color: "#fff",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        right: -40,
                        top: -40,
                        width: 160,
                        height: 160,
                        borderRadius: "50%",
                        background: "rgba(255,255,255,0.1)",
                      }}
                    />
                    <div
                      style={{
                        width: 64,
                        height: 64,
                        borderRadius: 16,
                        background: "rgba(255,255,255,0.2)",
                        backdropFilter: "blur(10px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1.6rem",
                        marginBottom: 18,
                        position: "relative",
                        animation: "rsFloat 4s ease-in-out infinite",
                      }}
                    >
                      <i className={`fa-regular ${c.icon || "fa-shield-check"}`}></i>
                    </div>
                    <h3 style={{ fontSize: "1.3rem", fontWeight: 800, margin: "0 0 6px", position: "relative" }}>{c.title}</h3>
                    {c.issuer && <div style={{ fontSize: "0.82rem", opacity: 0.9, fontWeight: 600, position: "relative" }}>{c.issuer}</div>}
                  </div>

                  <div style={{ padding: "26px 30px" }}>
                    {c.description && (
                      <p style={{ margin: "0 0 22px", color: "#374151", fontSize: "0.92rem", lineHeight: 1.7 }}>{c.description}</p>
                    )}
                    {c.url && (
                      <a
                        href={c.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="rs-btn rs-btn-outline"
                        style={{ fontSize: "0.82rem", padding: "10px 22px" }}
                      >
                        Visit Course
                        <i className="fa-regular fa-arrow-up-right-from-square"></i>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </ResearchLayout>
  );
}
